import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    color: ${vars.colorTextLight};
`;
